import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';

export interface GeotabAsset {
  vin: string;
  ridecareSerialNumber?: string;
  goDeviceGeotabSerialNumber?: string;
  ridecareDeviceGeotabSerialNumber?: string;
  geotabActivationStatus?: string;
  ridecareActivationStatus?: string;
}

export interface PaginatedAssetsResponse {
  assets: GeotabAsset[];
  nextStartFromKey: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class AssetSyncService {
  private readonly httpClient = inject(HttpClient);

  /* istanbul ignore next */
  private buildQueryParams(startFromKey?: string, limit = 100): HttpParams {
    const tenant = sessionStorage.getItem('tenant_'+sessionStorage.getItem('database')) || '';
    let params = new HttpParams()
      .set('tenant', tenant)
      .set('limit', String(limit));

    if (startFromKey) {
      params = params.set('startFromKey', startFromKey);
    }

    return params;
  }

  /* istanbul ignore next */
  getAssetSync(startFromKey?: string, limit = 100): Observable<PaginatedAssetsResponse> {
    const url = `${environment.dashboardURL}/geotab/assets`;
    const queryParams = this.buildQueryParams(startFromKey, limit);
    return this.httpClient.get<PaginatedAssetsResponse>(url, { params: queryParams });
  }
}
